export const ERRORS_TEXTS = {
  EMPTY: 'This field is required',
  INVALID_EMAIL:
    'Please enter a valid email address (e.g. email.address@roche.com)',
  INVALID_FORMAT: 'Please enter a valid format',
  EMPTY_SELECTION: 'This field is required. Please select an option',
  SLUG_DUPLICATE:
    'The Offering name already exists. Please try again with a different offering name',
  SLUG_LENGTH:
    'The Offering name is too short. Please provide an offering name that contains at least 3 characters',
  INVALID_URL: 'Please enter a valid URL (e.g. https://example.com)',
  DAY_CONFLICT_PART_1:
    'The following days are already assigned to another support hour entry:',
  DAY_CONFLICT_PART_2:
    'Please remove the current support hour entries to add the 24/7 support hours option',
};
